// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/user/v1/user.proto" (package "c1.api.user.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { ProfileType } from "../../profiletype/v1/profiletype";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Struct } from "../../../../google/protobuf/struct";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.user.v1.GetEmploymentStatusSearchTermsRequest
 */
export interface GetEmploymentStatusSearchTermsRequest {
}
/**
 * @generated from protobuf message c1.api.user.v1.GetEmploymentStatusSearchTermsResponse
 */
export interface GetEmploymentStatusSearchTermsResponse {
    /**
     * @generated from protobuf field: repeated string terms = 1;
     */
    terms: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.GetJobTitleSearchTermsRequest
 */
export interface GetJobTitleSearchTermsRequest {
}
/**
 * @generated from protobuf message c1.api.user.v1.GetJobTitleSearchTermsResponse
 */
export interface GetJobTitleSearchTermsResponse {
    /**
     * @generated from protobuf field: repeated string terms = 1;
     */
    terms: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.GetDepartmentSearchTermsRequest
 */
export interface GetDepartmentSearchTermsRequest {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.GetDepartmentSearchTermsResponse
 */
export interface GetDepartmentSearchTermsResponse {
    /**
     * @generated from protobuf field: repeated string terms = 1;
     */
    terms: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.CountAppUsersWithoutManagerRequest
 */
export interface CountAppUsersWithoutManagerRequest {
}
/**
 * @generated from protobuf message c1.api.user.v1.CountAppUsersWithoutManagerResponse
 */
export interface CountAppUsersWithoutManagerResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.user.v1.UsersWithoutManagerRequest
 */
export interface UsersWithoutManagerRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 3;
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.UsersWithoutManagerResponse
 */
export interface UsersWithoutManagerResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1;
     */
    list: UserView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusRequest
 */
export interface UsersWithUnspecifiedEmploymentStatusRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 3;
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusResponse
 */
export interface UsersWithUnspecifiedEmploymentStatusResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1;
     */
    list: UserView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * The user expand mask is used to indicate which related objects should be expanded in the response.
 * The supported paths are 'role_ids', 'manager_ids', 'delegated_user_id', 'directory_ids', and '*'.
 *
 * @generated from protobuf message c1.api.user.v1.UserExpandMask
 */
export interface UserExpandMask {
    /**
     * An array of paths to be expanded in the response.
     *
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * The UserView object provides a user response object, as well as JSONPATHs to related objects provided by expanders.
 *
 * @generated from protobuf message c1.api.user.v1.UserView
 */
export interface UserView {
    /**
     * The user object being returned by the request.
     *
     * @generated from protobuf field: c1.api.user.v1.User user = 1;
     */
    user?: User;
    /**
     * JSONPATH expression indicating the location of the roles of the current user in the expanded array.
     *
     * @generated from protobuf field: string roles_path = 2;
     */
    rolesPath: string;
    /**
     * JSONPATH expression indicating the location of the user objects that managed the current user in the expanded array.
     *
     * @generated from protobuf field: string managers_path = 3;
     */
    managersPath: string;
    /**
     * JSONPATH expression indicating the location of the user objects of delegates of the current user in the expanded array.
     *
     * @generated from protobuf field: string delegated_user_path = 4;
     */
    delegatedUserPath: string;
    /**
     * JSONPATH expression indicating the location of directory objects in the expanded array.
     *
     * @generated from protobuf field: string directories_path = 5;
     */
    directoriesPath: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeMappingSource
 */
export interface UserAttributeMappingSource {
    /**
     * @generated from protobuf field: string user_attribute_mapping_id = 1;
     */
    userAttributeMappingId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string app_user_profile_attribute_key = 4;
     */
    appUserProfileAttributeKey: string;
    /**
     * @generated from protobuf field: string value = 5;
     */
    value: string;
}
/**
 * A reference to a user.
 *
 * @generated from protobuf message c1.api.user.v1.UserRef
 */
export interface UserRef {
    /**
     * The id of the user.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * The User object provides all of the details for an user, as well as some configuration.
 *
 * @generated from protobuf message c1.api.user.v1.User
 */
export interface User {
    /**
     * A unique identifier of the user.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The display name of the user.
     *
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * This is the user's email.
     *
     * @generated from protobuf field: string email = 3;
     */
    email: string;
    /**
     * This is a list of all of the user's emails from app users.
     *
     * @generated from protobuf field: repeated string emails = 24;
     */
    emails: string[];
    /**
     * A list of source data for the email attribute.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource email_sources = 30;
     */
    emailSources: UserAttributeMappingSource[];
    /**
     * This is the user's primary username. Typically sourced from the primary directory.
     *
     * @generated from protobuf field: string username = 25;
     */
    username: string;
    /**
     * This is a list of all of the user's usernames from app users.
     *
     * @generated from protobuf field: repeated string usernames = 26;
     */
    usernames: string[];
    /**
     * A list of source data for the usernames attribute.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource username_sources = 27;
     */
    usernameSources: UserAttributeMappingSource[];
    /**
     * This is a list of all of the user's employee IDs from app users.
     *
     * @generated from protobuf field: repeated string employee_ids = 28;
     */
    employeeIds: string[];
    /**
     * A list of source data for the employee IDs attribute.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource employee_id_sources = 29;
     */
    employeeIdSources: UserAttributeMappingSource[];
    /**
     * The status of the user in the system.
     *
     * @generated from protobuf field: c1.api.user.v1.UserStatus status = 4;
     */
    status: UserStatus;
    /**
     * A list of unique identifiers that maps to ConductorOne's user roles let you assign users permissions tailored to the work they do in the software.
     *
     * @generated from protobuf field: repeated string role_ids = 5;
     */
    roleIds: string[];
    /**
     * A list of ids of the user's managers.
     *
     * @generated from protobuf field: repeated string manager_ids = 6;
     */
    managerIds: string[];
    /**
     * A list of objects mapped based on managerId attribute mappings configured in the system.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource manager_sources = 11;
     */
    managerSources: UserAttributeMappingSource[];
    /**
     * The datetime, in RFC3339 format, of when the User was created in Conductor One.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 7;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the User was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 8;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the User was deleted in Conductor One.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 9;
     */
    deletedAt?: Timestamp;
    /**
     * The id of the user to whom tasks will be automatically reassigned to.
     *
     * @generated from protobuf field: string delegated_user_id = 10;
     */
    delegatedUserId: string;
    /**
     * The status of the user in the directory.
     *
     * @generated from protobuf field: c1.api.user.v1.UserStatus directory_status = 12;
     */
    directoryStatus: UserStatus;
    /**
     * A list of objects mapped based on directoryStatus attribute mappings configured in the system.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource directory_status_sources = 13;
     */
    directoryStatusSources: UserAttributeMappingSource[];
    /**
     * The job title of the user.
     *
     * @generated from protobuf field: string job_title = 14;
     */
    jobTitle: string;
    /**
     * A list of objects mapped based on jobTitle attribute mappings configured in the system.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource job_title_sources = 15;
     */
    jobTitleSources: UserAttributeMappingSource[];
    /**
     * The department which the user belongs to in the organization.
     *
     * @generated from protobuf field: string department = 16;
     */
    department: string;
    /**
     * A list of objects mapped based on department attribute mappings configured in the system.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource department_sources = 17;
     */
    departmentSources: UserAttributeMappingSource[];
    /**
     * The users employment status.
     *
     * @generated from protobuf field: string employment_status = 18;
     */
    employmentStatus: string;
    /**
     * A list of objects mapped based on employmentStatus attribute mappings configured in the system.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource employment_status_sources = 19;
     */
    employmentStatusSources: UserAttributeMappingSource[];
    /**
     * The employment type of the user.
     *
     * @generated from protobuf field: string employment_type = 20;
     */
    employmentType: string;
    /**
     * A list of objects mapped based on employmentType attribute mappings configured in the system.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource employment_type_sources = 21;
     */
    employmentTypeSources: UserAttributeMappingSource[];
    /**
     * A list of unique ids that represent different directories.
     *
     * @generated from protobuf field: repeated string directory_ids = 22;
     */
    directoryIds: string[];
    /**
     * TODO: Eventually this should be removed in favor of attributes. Analysis should use attributes
     *
     * @generated from protobuf field: google.protobuf.Struct profile = 23;
     */
    profile?: Struct;
    /**
     * The type of the user.
     *
     * @generated from protobuf field: c1.api.user.v1.UserType type = 31;
     */
    type: UserType;
}
/**
 * @generated from protobuf message c1.api.user.v1.ExpiringUserDelegationBinding
 */
export interface ExpiringUserDelegationBinding {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * @generated from protobuf field: string delegated_user_id = 2;
     */
    delegatedUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_at = 3;
     */
    startAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expiration_at = 4;
     */
    expirationAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7;
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.user.v1.IntrospectRequest
 */
export interface IntrospectRequest {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 1;
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.IntrospectResponse
 */
export interface IntrospectResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserView user_view = 1;
     */
    userView?: UserView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserServiceGetRequest
 */
export interface UserServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 2;
     */
    expandMask?: UserExpandMask;
}
/**
 * The UserServiceGetResponse returns a user view which has a user including JSONPATHs to the expanded items in the expanded array.
 *
 * @generated from protobuf message c1.api.user.v1.UserServiceGetResponse
 */
export interface UserServiceGetResponse {
    /**
     * A view of the user, contains the serialized user and paths to objects referenced by the user.
     *
     * @generated from protobuf field: c1.api.user.v1.UserView user_view = 1;
     */
    userView?: UserView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserServiceGetUsersByIDsRequest
 */
export interface UserServiceGetUsersByIDsRequest {
    /**
     * @generated from protobuf field: repeated string ids = 1;
     */
    ids: string[];
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 2;
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserServiceGetUsersByIDsResponse
 */
export interface UserServiceGetUsersByIDsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserView items = 1;
     */
    items: UserView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.user.v1.UserServiceListRequest
 */
export interface UserServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 3;
     */
    expandMask?: UserExpandMask;
}
/**
 * The UserServiceListResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.user.v1.UserServiceListResponse
 */
export interface UserServiceListResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1;
     */
    list: UserView[];
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * Search for users based on some filters.
 *
 * @generated from protobuf message c1.api.user.v1.SearchUsersRequest
 */
export interface SearchUsersRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Query the apps with a fuzzy search on display name and emails.
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * The expand mask defines the list of paths to be expanded in the return value.
     *
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 6;
     */
    expandMask?: UserExpandMask;
    /**
     * Search for users that have any of the statuses on this list. This can only be ENABLED, DISABLED, and DELETED
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserStatus user_statuses = 7;
     */
    userStatuses: UserStatus[];
    /**
     * Search for users that have any of the role IDs on this list.
     *
     * @generated from protobuf field: repeated string role_ids = 8;
     */
    roleIds: string[];
    /**
     * An array of users IDs to exclude from the results.
     *
     * @generated from protobuf field: repeated string exclude_ids = 9;
     */
    excludeIds: string[];
    /**
     * Deprecated. Use refs array instead.
     *
     * @generated from protobuf field: repeated string ids = 10;
     */
    ids: string[];
    /**
     * An array of user refs to restrict the return values to by ID.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef refs = 11;
     */
    refs: UserRef[];
    /**
     * Search for users based on their email (exact match).
     *
     * @generated from protobuf field: string email = 12;
     */
    email: string;
    /**
     * An array of types to exclude from the results.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserType exclude_types = 13;
     */
    excludeTypes: UserType[];
    /**
     * Search for users that have any of the manager IDs on this list.
     *
     * @generated from protobuf field: repeated string manager_ids = 14;
     */
    managerIds: string[];
    /**
     * Search for users that have any of the job titles on this list.
     *
     * @generated from protobuf field: repeated string job_titles = 15;
     */
    jobTitles: string[];
    /**
     * Search for users that have any of the departments on this list.
     *
     * @generated from protobuf field: repeated string departments = 16;
     */
    departments: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchUsersResponse
 */
export interface SearchUsersResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1;
     */
    list: UserView[];
    /**
     * List of related objects
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchManagedUsersRequest
 */
export interface SearchManagedUsersRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string manager_id = 3;
     */
    managerId: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string exclude_user_ids = 5;
     */
    excludeUserIds: string[];
    /**
     * @generated from protobuf field: repeated string user_ids = 6;
     */
    userIds: string[];
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 7;
     */
    expandMask?: UserExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserStatus user_statuses = 8;
     */
    userStatuses: UserStatus[];
    /**
     * @generated from protobuf field: repeated string role_ids = 9;
     */
    roleIds: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchManagedUsersResponse
 */
export interface SearchManagedUsersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1;
     */
    list: UserView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchManagedUsersForAccessRequestsRequest
 */
export interface SearchManagedUsersForAccessRequestsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string manager_id = 3;
     */
    managerId: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string exclude_user_ids = 5;
     */
    excludeUserIds: string[];
    /**
     * @generated from protobuf field: repeated string user_ids = 6;
     */
    userIds: string[];
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 7;
     */
    expandMask?: UserExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserStatus user_statuses = 8;
     */
    userStatuses: UserStatus[];
    /**
     * @generated from protobuf field: repeated string role_ids = 9;
     */
    roleIds: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchManagedUsersForAccessRequestsResponse
 */
export interface SearchManagedUsersForAccessRequestsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1;
     */
    list: UserView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UpdateUserRequest
 */
export interface UpdateUserRequest {
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 1;
     */
    user?: User;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 3;
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetDelegatedUserRequest
 */
export interface SetDelegatedUserRequest {
    /**
     * @generated from protobuf field: string delegated_user_id = 1;
     */
    delegatedUserId: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 2;
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetUserRolesRequest
 */
export interface SetUserRolesRequest {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * @generated from protobuf field: repeated string role_ids = 2;
     */
    roleIds: string[];
    /**
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 3;
     */
    expandMask?: UserExpandMask;
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchUsersWithCELRequest
 */
export interface SearchUsersWithCELRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Query the apps with a fuzzy search on display name and emails.
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * The expand mask defines the list of paths to be expanded in the return value.
     *
     * @generated from protobuf field: c1.api.user.v1.UserExpandMask expand_mask = 4;
     */
    expandMask?: UserExpandMask;
    /**
     * Search for users based on their email (exact match).
     *
     * @generated from protobuf field: string email = 5;
     */
    email: string;
    /**
     * The CEL expression to filter the users.
     *
     * @generated from protobuf field: string expression = 6;
     */
    expression: string;
    /**
     * @generated from protobuf field: repeated string exclude_user_ids = 7;
     */
    excludeUserIds: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchUsersWithCELResponse
 */
export interface SearchUsersWithCELResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserView list = 1;
     */
    list: UserView[];
    /**
     * List of related objects
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.UserAttributeWithProfileTypeSource
 */
export interface UserAttributeWithProfileTypeSource {
    /**
     * @generated from protobuf field: string profile_attribute_key = 1;
     */
    profileAttributeKey: string;
    /**
     * @generated from protobuf field: string profile_attribute_value = 2;
     */
    profileAttributeValue: string;
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileType profile_types = 3;
     */
    profileTypes: ProfileType[];
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchUserAttributesWithProfileTypeSourceRequest
 */
export interface SearchUserAttributesWithProfileTypeSourceRequest {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchUserAttributesWithProfileTypeSourceResponse
 */
export interface SearchUserAttributesWithProfileTypeSourceResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeWithProfileTypeSource list = 1;
     */
    list: UserAttributeWithProfileTypeSource[];
}
/**
 * @generated from protobuf message c1.api.user.v1.AgentView
 */
export interface AgentView {
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 1;
     */
    user?: User;
    /**
     * @generated from protobuf field: string instructions = 2;
     */
    instructions: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.AgentInstructionsType agent_instructions_type = 4;
     */
    agentInstructionsType: AgentInstructionsType;
}
/**
 * @generated from protobuf message c1.api.user.v1.CreateAgentRequest
 */
export interface CreateAgentRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.CreateAgentResponse
 */
export interface CreateAgentResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.AgentView agent_view = 1;
     */
    agentView?: AgentView;
}
/**
 * @generated from protobuf message c1.api.user.v1.GetAgentRequest
 */
export interface GetAgentRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.GetAgentResponse
 */
export interface GetAgentResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.AgentView agent_view = 1;
     */
    agentView?: AgentView;
}
/**
 * @generated from protobuf message c1.api.user.v1.ListAgentsRequest
 */
export interface ListAgentsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.ListAgentsResponse
 */
export interface ListAgentsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.AgentView list = 1;
     */
    list: AgentView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetAgentInstructionsRequest
 */
export interface SetAgentInstructionsRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string instructions = 2;
     */
    instructions: string;
    /**
     * @generated from protobuf field: c1.api.user.v1.AgentInstructionsType agent_instructions_type = 3;
     */
    agentInstructionsType: AgentInstructionsType;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetAgentInstructionsResponse
 */
export interface SetAgentInstructionsResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.AgentView agent_view = 1;
     */
    agentView?: AgentView;
}
/**
 * @generated from protobuf message c1.api.user.v1.DeleteAgentRequest
 */
export interface DeleteAgentRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.DeleteAgentResponse
 */
export interface DeleteAgentResponse {
}
/**
 * @generated from protobuf message c1.api.user.v1.AgentRef
 */
export interface AgentRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchAgentsRequest
 */
export interface SearchAgentsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.AgentRef refs = 3;
     */
    refs: AgentRef[];
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.SearchAgentsResponse
 */
export interface SearchAgentsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.AgentView list = 1;
     */
    list: AgentView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.GetExpiringUserDelegationBindingRequest
 */
export interface GetExpiringUserDelegationBindingRequest {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.GetExpiringUserDelegationBindingResponse
 */
export interface GetExpiringUserDelegationBindingResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.ExpiringUserDelegationBinding item = 1;
     */
    item?: ExpiringUserDelegationBinding;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingByAdminRequest
 */
export interface SetExpiringUserDelegationBindingByAdminRequest {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * @generated from protobuf field: string delegated_user_id = 2;
     */
    delegatedUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp delegation_start_at = 3;
     */
    delegationStartAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp delegation_expire_at = 4;
     */
    delegationExpireAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingByAdminResponse
 */
export interface SetExpiringUserDelegationBindingByAdminResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.ExpiringUserDelegationBinding item = 1;
     */
    item?: ExpiringUserDelegationBinding;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingSelfRequest
 */
export interface SetExpiringUserDelegationBindingSelfRequest {
    /**
     * @generated from protobuf field: string delegated_user_id = 1;
     */
    delegatedUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp delegation_start_at = 2;
     */
    delegationStartAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp delegation_expire_at = 3;
     */
    delegationExpireAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingSelfResponse
 */
export interface SetExpiringUserDelegationBindingSelfResponse {
    /**
     * @generated from protobuf field: c1.api.user.v1.ExpiringUserDelegationBinding item = 1;
     */
    item?: ExpiringUserDelegationBinding;
}
/**
 * @generated from protobuf message c1.api.user.v1.GetUserProfileTypesRequest
 */
export interface GetUserProfileTypesRequest {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.user.v1.GetUserProfileTypesResponse
 */
export interface GetUserProfileTypesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.profiletype.v1.ProfileType profile_types = 1;
     */
    profileTypes: ProfileType[];
}
/**
 * @generated from protobuf message c1.api.user.v1.PreviewUserProfileWithProfileTypesRequest
 */
export interface PreviewUserProfileWithProfileTypesRequest {
    /**
     * The user to preview profile changes for
     *
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * ProfileType IDs to add to the user's current set
     *
     * @generated from protobuf field: repeated string profile_type_ids_to_add = 2;
     */
    profileTypeIdsToAdd: string[];
    /**
     * ProfileType IDs to remove from the user's current set
     *
     * @generated from protobuf field: repeated string profile_type_ids_to_remove = 3;
     */
    profileTypeIdsToRemove: string[];
}
/**
 * @generated from protobuf message c1.api.user.v1.PreviewUserProfileWithProfileTypesResponse
 */
export interface PreviewUserProfileWithProfileTypesResponse {
    /**
     * The user's current profile with their actual ProfileType assignments
     *
     * @generated from protobuf field: google.protobuf.Struct current_profile = 1;
     */
    currentProfile?: Struct;
    /**
     * The projected profile if the user had the specified ProfileTypes
     *
     * @generated from protobuf field: google.protobuf.Struct projected_profile = 2;
     */
    projectedProfile?: Struct;
    /**
     * Automation rules, access reviews, and other entities that reference the changing profile fields
     *
     * @generated from protobuf field: repeated c1.api.user.v1.AffectedReference potentially_affected_references = 3;
     */
    potentiallyAffectedReferences: AffectedReference[];
}
/**
 * @generated from protobuf message c1.api.user.v1.AffectedReference
 */
export interface AffectedReference {
    /**
     * The type of entity
     *
     * @generated from protobuf field: c1.api.user.v1.AffectedReferenceEntityType entity_type = 1;
     */
    entityType: AffectedReferenceEntityType;
    /**
     * The ID of the entity
     *
     * @generated from protobuf field: string entity_id = 2;
     */
    entityId: string;
    /**
     * The display name of the entity
     *
     * @generated from protobuf field: string entity_name = 3;
     */
    entityName: string;
    /**
     * The CEL expression that references profile fields
     *
     * @generated from protobuf field: string cel_expression = 4;
     */
    celExpression: string;
    /**
     * The profile fields that are referenced in the CEL expression and are changing
     *
     * @generated from protobuf field: repeated string referenced_changing_fields = 5;
     */
    referencedChangingFields: string[];
    /**
     * Optional app ID for group automations (only populated for entity_type = "group_automation")
     *
     * @generated from protobuf field: string app_id = 6;
     */
    appId: string;
}
/**
 * Set the avatar for a user.
 * Endpoint Requirements:
 * - The avatar must be a valid PNG, JPEG or WebP image.
 * - The avatar must be less than 1mb in size.
 * - The avatar must be a square image.
 *
 * @generated from protobuf message c1.api.user.v1.SetUserAvatarRequest
 */
export interface SetUserAvatarRequest {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * @generated from protobuf field: bytes data = 2;
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetUserAvatarResponse
 */
export interface SetUserAvatarResponse {
}
/**
 * Set the avatar for the current user (self).
 * Endpoint Requirements:
 * - The avatar must be a valid PNG, JPEG or WebP image.
 * - The avatar must be less than 1mb in size.
 * - The avatar must be a square image.
 *
 * @generated from protobuf message c1.api.user.v1.SetUserAvatarSelfRequest
 */
export interface SetUserAvatarSelfRequest {
    /**
     * @generated from protobuf field: bytes data = 1;
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.user.v1.SetUserAvatarSelfResponse
 */
export interface SetUserAvatarSelfResponse {
}
/**
 * Different user statuses
 *
 * @generated from protobuf enum c1.api.user.v1.UserStatus
 */
export enum UserStatus {
    /**
     * Indicates that the user account status is unknown.
     *
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * Indicates that the user account is active.
     *
     * @generated from protobuf enum value: ENABLED = 1;
     */
    ENABLED = 1,
    /**
     * Indicates that the user account is disabled.
     *
     * @generated from protobuf enum value: DISABLED = 2;
     */
    DISABLED = 2,
    /**
     * Indicates that the user account is deleted.
     *
     * @generated from protobuf enum value: DELETED = 3;
     */
    DELETED = 3
}
/**
 * @generated from protobuf enum c1.api.user.v1.UserType
 */
export enum UserType {
    /**
     * Indicates that the user type is unknown.
     *
     * @generated from protobuf enum value: USER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Indicates that the user is a system.
     *
     * @generated from protobuf enum value: USER_TYPE_SYSTEM = 1;
     */
    SYSTEM = 1,
    /**
     * Indicates that the user is a human.
     *
     * @generated from protobuf enum value: USER_TYPE_HUMAN = 2;
     */
    HUMAN = 2,
    /**
     * Indicates that the user is a service.
     *
     * @generated from protobuf enum value: USER_TYPE_SERVICE = 3;
     */
    SERVICE = 3,
    /**
     * Indicates that the user is an agent.
     *
     * @generated from protobuf enum value: USER_TYPE_AGENT = 4;
     */
    AGENT = 4
}
/**
 * @generated from protobuf enum c1.api.user.v1.AgentInstructionsType
 */
export enum AgentInstructionsType {
    /**
     * @generated from protobuf enum value: AGENT_INSTRUCTIONS_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: AGENT_INSTRUCTIONS_TYPE_CONCISE = 1;
     */
    CONCISE = 1,
    /**
     * @generated from protobuf enum value: AGENT_INSTRUCTIONS_TYPE_VERBOSE = 2;
     */
    VERBOSE = 2,
    /**
     * @generated from protobuf enum value: AGENT_INSTRUCTIONS_TYPE_CUSTOM = 3;
     */
    CUSTOM = 3
}
/**
 * Represents an entity (workflow, access review, etc.) that may be affected by profile changes
 *
 * @generated from protobuf enum c1.api.user.v1.AffectedReferenceEntityType
 */
export enum AffectedReferenceEntityType {
    /**
     * @generated from protobuf enum value: AFFECTED_REFERENCE_ENTITY_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: AFFECTED_REFERENCE_ENTITY_TYPE_WORKFLOW = 1;
     */
    WORKFLOW = 1,
    /**
     * @generated from protobuf enum value: AFFECTED_REFERENCE_ENTITY_TYPE_ACCESS_REVIEW = 2;
     */
    ACCESS_REVIEW = 2,
    /**
     * @generated from protobuf enum value: AFFECTED_REFERENCE_ENTITY_TYPE_ACCESS_REVIEW_TEMPLATE = 3;
     */
    ACCESS_REVIEW_TEMPLATE = 3,
    /**
     * @generated from protobuf enum value: AFFECTED_REFERENCE_ENTITY_TYPE_GROUP_AUTOMATION = 4;
     */
    GROUP_AUTOMATION = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class GetEmploymentStatusSearchTermsRequest$Type extends MessageType<GetEmploymentStatusSearchTermsRequest> {
    constructor() {
        super("c1.api.user.v1.GetEmploymentStatusSearchTermsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetEmploymentStatusSearchTermsRequest
 */
export const GetEmploymentStatusSearchTermsRequest = new GetEmploymentStatusSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetEmploymentStatusSearchTermsResponse$Type extends MessageType<GetEmploymentStatusSearchTermsResponse> {
    constructor() {
        super("c1.api.user.v1.GetEmploymentStatusSearchTermsResponse", [
            { no: 1, name: "terms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetEmploymentStatusSearchTermsResponse
 */
export const GetEmploymentStatusSearchTermsResponse = new GetEmploymentStatusSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJobTitleSearchTermsRequest$Type extends MessageType<GetJobTitleSearchTermsRequest> {
    constructor() {
        super("c1.api.user.v1.GetJobTitleSearchTermsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetJobTitleSearchTermsRequest
 */
export const GetJobTitleSearchTermsRequest = new GetJobTitleSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetJobTitleSearchTermsResponse$Type extends MessageType<GetJobTitleSearchTermsResponse> {
    constructor() {
        super("c1.api.user.v1.GetJobTitleSearchTermsResponse", [
            { no: 1, name: "terms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetJobTitleSearchTermsResponse
 */
export const GetJobTitleSearchTermsResponse = new GetJobTitleSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDepartmentSearchTermsRequest$Type extends MessageType<GetDepartmentSearchTermsRequest> {
    constructor() {
        super("c1.api.user.v1.GetDepartmentSearchTermsRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetDepartmentSearchTermsRequest
 */
export const GetDepartmentSearchTermsRequest = new GetDepartmentSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDepartmentSearchTermsResponse$Type extends MessageType<GetDepartmentSearchTermsResponse> {
    constructor() {
        super("c1.api.user.v1.GetDepartmentSearchTermsResponse", [
            { no: 1, name: "terms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetDepartmentSearchTermsResponse
 */
export const GetDepartmentSearchTermsResponse = new GetDepartmentSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountAppUsersWithoutManagerRequest$Type extends MessageType<CountAppUsersWithoutManagerRequest> {
    constructor() {
        super("c1.api.user.v1.CountAppUsersWithoutManagerRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.CountAppUsersWithoutManagerRequest
 */
export const CountAppUsersWithoutManagerRequest = new CountAppUsersWithoutManagerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountAppUsersWithoutManagerResponse$Type extends MessageType<CountAppUsersWithoutManagerResponse> {
    constructor() {
        super("c1.api.user.v1.CountAppUsersWithoutManagerResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.CountAppUsersWithoutManagerResponse
 */
export const CountAppUsersWithoutManagerResponse = new CountAppUsersWithoutManagerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsersWithoutManagerRequest$Type extends MessageType<UsersWithoutManagerRequest> {
    constructor() {
        super("c1.api.user.v1.UsersWithoutManagerRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UsersWithoutManagerRequest
 */
export const UsersWithoutManagerRequest = new UsersWithoutManagerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsersWithoutManagerResponse$Type extends MessageType<UsersWithoutManagerResponse> {
    constructor() {
        super("c1.api.user.v1.UsersWithoutManagerResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UsersWithoutManagerResponse
 */
export const UsersWithoutManagerResponse = new UsersWithoutManagerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsersWithUnspecifiedEmploymentStatusRequest$Type extends MessageType<UsersWithUnspecifiedEmploymentStatusRequest> {
    constructor() {
        super("c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusRequest
 */
export const UsersWithUnspecifiedEmploymentStatusRequest = new UsersWithUnspecifiedEmploymentStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsersWithUnspecifiedEmploymentStatusResponse$Type extends MessageType<UsersWithUnspecifiedEmploymentStatusResponse> {
    constructor() {
        super("c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusResponse
 */
export const UsersWithUnspecifiedEmploymentStatusResponse = new UsersWithUnspecifiedEmploymentStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserExpandMask$Type extends MessageType<UserExpandMask> {
    constructor() {
        super("c1.api.user.v1.UserExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "role_ids", "manager_ids", "delegated_user_iddirectory_ids"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserExpandMask
 */
export const UserExpandMask = new UserExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserView$Type extends MessageType<UserView> {
    constructor() {
        super("c1.api.user.v1.UserView", [
            { no: 1, name: "user", kind: "message", T: () => User, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "roles_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "managers_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "delegated_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "directories_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserView
 */
export const UserView = new UserView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeMappingSource$Type extends MessageType<UserAttributeMappingSource> {
    constructor() {
        super("c1.api.user.v1.UserAttributeMappingSource", [
            { no: 1, name: "user_attribute_mapping_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_user_profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeMappingSource
 */
export const UserAttributeMappingSource = new UserAttributeMappingSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserRef$Type extends MessageType<UserRef> {
    constructor() {
        super("c1.api.user.v1.UserRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserRef
 */
export const UserRef = new UserRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class User$Type extends MessageType<User> {
    constructor() {
        super("c1.api.user.v1.User", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 24, name: "emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 30, name: "email_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 25, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 26, name: "usernames", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 27, name: "username_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 28, name: "employee_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 29, name: "employee_id_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "status", kind: "enum", T: () => ["c1.api.user.v1.UserStatus", UserStatus] },
            { no: 5, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "manager_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "manager_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "delegated_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "directory_status", kind: "enum", T: () => ["c1.api.user.v1.UserStatus", UserStatus], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "directory_status_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 14, name: "job_title", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 15, name: "job_title_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 16, name: "department", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 17, name: "department_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 18, name: "employment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 19, name: "employment_status_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 20, name: "employment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 21, name: "employment_type_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 22, name: "directory_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 23, name: "profile", kind: "message", T: () => Struct, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 31, name: "type", kind: "enum", T: () => ["c1.api.user.v1.UserType", UserType, "USER_TYPE_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ], { "policy.v1.msg": { enabled: true, name: "user", keyFields: ["id"] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.User
 */
export const User = new User$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExpiringUserDelegationBinding$Type extends MessageType<ExpiringUserDelegationBinding> {
    constructor() {
        super("c1.api.user.v1.ExpiringUserDelegationBinding", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "delegated_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "start_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "expiration_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.ExpiringUserDelegationBinding
 */
export const ExpiringUserDelegationBinding = new ExpiringUserDelegationBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntrospectRequest$Type extends MessageType<IntrospectRequest> {
    constructor() {
        super("c1.api.user.v1.IntrospectRequest", [
            { no: 1, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.IntrospectRequest
 */
export const IntrospectRequest = new IntrospectRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntrospectResponse$Type extends MessageType<IntrospectResponse> {
    constructor() {
        super("c1.api.user.v1.IntrospectResponse", [
            { no: 1, name: "user_view", kind: "message", T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.IntrospectResponse
 */
export const IntrospectResponse = new IntrospectResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserServiceGetRequest$Type extends MessageType<UserServiceGetRequest> {
    constructor() {
        super("c1.api.user.v1.UserServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserServiceGetRequest
 */
export const UserServiceGetRequest = new UserServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserServiceGetResponse$Type extends MessageType<UserServiceGetResponse> {
    constructor() {
        super("c1.api.user.v1.UserServiceGetResponse", [
            { no: 1, name: "user_view", kind: "message", T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserServiceGetResponse
 */
export const UserServiceGetResponse = new UserServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserServiceGetUsersByIDsRequest$Type extends MessageType<UserServiceGetUsersByIDsRequest> {
    constructor() {
        super("c1.api.user.v1.UserServiceGetUsersByIDsRequest", [
            { no: 1, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserServiceGetUsersByIDsRequest
 */
export const UserServiceGetUsersByIDsRequest = new UserServiceGetUsersByIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserServiceGetUsersByIDsResponse$Type extends MessageType<UserServiceGetUsersByIDsResponse> {
    constructor() {
        super("c1.api.user.v1.UserServiceGetUsersByIDsResponse", [
            { no: 1, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserServiceGetUsersByIDsResponse
 */
export const UserServiceGetUsersByIDsResponse = new UserServiceGetUsersByIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserServiceListRequest$Type extends MessageType<UserServiceListRequest> {
    constructor() {
        super("c1.api.user.v1.UserServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserServiceListRequest
 */
export const UserServiceListRequest = new UserServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserServiceListResponse$Type extends MessageType<UserServiceListResponse> {
    constructor() {
        super("c1.api.user.v1.UserServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserServiceListResponse
 */
export const UserServiceListResponse = new UserServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsersRequest$Type extends MessageType<SearchUsersRequest> {
    constructor() {
        super("c1.api.user.v1.SearchUsersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => UserExpandMask },
            { no: 7, name: "user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.user.v1.UserStatus", UserStatus], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 8, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true } } } },
            { no: 9, name: "exclude_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 10, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 11, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 12, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { email: true, ignoreEmpty: true } } } },
            { no: 13, name: "exclude_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.user.v1.UserType", UserType, "USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true } } } },
            { no: 14, name: "manager_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 15, name: "job_titles", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minLen: "1", maxLen: "255" } } } } } },
            { no: 16, name: "departments", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minLen: "1", maxLen: "255" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchUsersRequest
 */
export const SearchUsersRequest = new SearchUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsersResponse$Type extends MessageType<SearchUsersResponse> {
    constructor() {
        super("c1.api.user.v1.SearchUsersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchUsersResponse
 */
export const SearchUsersResponse = new SearchUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchManagedUsersRequest$Type extends MessageType<SearchManagedUsersRequest> {
    constructor() {
        super("c1.api.user.v1.SearchManagedUsersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "manager_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "exclude_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => UserExpandMask },
            { no: 8, name: "user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.user.v1.UserStatus", UserStatus], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 9, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchManagedUsersRequest
 */
export const SearchManagedUsersRequest = new SearchManagedUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchManagedUsersResponse$Type extends MessageType<SearchManagedUsersResponse> {
    constructor() {
        super("c1.api.user.v1.SearchManagedUsersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchManagedUsersResponse
 */
export const SearchManagedUsersResponse = new SearchManagedUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchManagedUsersForAccessRequestsRequest$Type extends MessageType<SearchManagedUsersForAccessRequestsRequest> {
    constructor() {
        super("c1.api.user.v1.SearchManagedUsersForAccessRequestsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "manager_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "exclude_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => UserExpandMask },
            { no: 8, name: "user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.user.v1.UserStatus", UserStatus], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 9, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchManagedUsersForAccessRequestsRequest
 */
export const SearchManagedUsersForAccessRequestsRequest = new SearchManagedUsersForAccessRequestsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchManagedUsersForAccessRequestsResponse$Type extends MessageType<SearchManagedUsersForAccessRequestsResponse> {
    constructor() {
        super("c1.api.user.v1.SearchManagedUsersForAccessRequestsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchManagedUsersForAccessRequestsResponse
 */
export const SearchManagedUsersForAccessRequestsResponse = new SearchManagedUsersForAccessRequestsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserRequest$Type extends MessageType<UpdateUserRequest> {
    constructor() {
        super("c1.api.user.v1.UpdateUserRequest", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UpdateUserRequest
 */
export const UpdateUserRequest = new UpdateUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetDelegatedUserRequest$Type extends MessageType<SetDelegatedUserRequest> {
    constructor() {
        super("c1.api.user.v1.SetDelegatedUserRequest", [
            { no: 1, name: "delegated_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetDelegatedUserRequest
 */
export const SetDelegatedUserRequest = new SetDelegatedUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetUserRolesRequest$Type extends MessageType<SetUserRolesRequest> {
    constructor() {
        super("c1.api.user.v1.SetUserRolesRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => UserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetUserRolesRequest
 */
export const SetUserRolesRequest = new SetUserRolesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsersWithCELRequest$Type extends MessageType<SearchUsersWithCELRequest> {
    constructor() {
        super("c1.api.user.v1.SearchUsersWithCELRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => UserExpandMask },
            { no: 5, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { email: true, ignoreEmpty: true } } } },
            { no: 6, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0" } } } },
            { no: 7, name: "exclude_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchUsersWithCELRequest
 */
export const SearchUsersWithCELRequest = new SearchUsersWithCELRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsersWithCELResponse$Type extends MessageType<SearchUsersWithCELResponse> {
    constructor() {
        super("c1.api.user.v1.SearchUsersWithCELResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchUsersWithCELResponse
 */
export const SearchUsersWithCELResponse = new SearchUsersWithCELResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAttributeWithProfileTypeSource$Type extends MessageType<UserAttributeWithProfileTypeSource> {
    constructor() {
        super("c1.api.user.v1.UserAttributeWithProfileTypeSource", [
            { no: 1, name: "profile_attribute_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "profile_attribute_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "profile_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileType }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.UserAttributeWithProfileTypeSource
 */
export const UserAttributeWithProfileTypeSource = new UserAttributeWithProfileTypeSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUserAttributesWithProfileTypeSourceRequest$Type extends MessageType<SearchUserAttributesWithProfileTypeSourceRequest> {
    constructor() {
        super("c1.api.user.v1.SearchUserAttributesWithProfileTypeSourceRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchUserAttributesWithProfileTypeSourceRequest
 */
export const SearchUserAttributesWithProfileTypeSourceRequest = new SearchUserAttributesWithProfileTypeSourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUserAttributesWithProfileTypeSourceResponse$Type extends MessageType<SearchUserAttributesWithProfileTypeSourceResponse> {
    constructor() {
        super("c1.api.user.v1.SearchUserAttributesWithProfileTypeSourceResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeWithProfileTypeSource }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchUserAttributesWithProfileTypeSourceResponse
 */
export const SearchUserAttributesWithProfileTypeSourceResponse = new SearchUserAttributesWithProfileTypeSourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentView$Type extends MessageType<AgentView> {
    constructor() {
        super("c1.api.user.v1.AgentView", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "agent_instructions_type", kind: "enum", T: () => ["c1.api.user.v1.AgentInstructionsType", AgentInstructionsType, "AGENT_INSTRUCTIONS_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.AgentView
 */
export const AgentView = new AgentView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAgentRequest$Type extends MessageType<CreateAgentRequest> {
    constructor() {
        super("c1.api.user.v1.CreateAgentRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.CreateAgentRequest
 */
export const CreateAgentRequest = new CreateAgentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAgentResponse$Type extends MessageType<CreateAgentResponse> {
    constructor() {
        super("c1.api.user.v1.CreateAgentResponse", [
            { no: 1, name: "agent_view", kind: "message", T: () => AgentView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.CreateAgentResponse
 */
export const CreateAgentResponse = new CreateAgentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgentRequest$Type extends MessageType<GetAgentRequest> {
    constructor() {
        super("c1.api.user.v1.GetAgentRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetAgentRequest
 */
export const GetAgentRequest = new GetAgentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAgentResponse$Type extends MessageType<GetAgentResponse> {
    constructor() {
        super("c1.api.user.v1.GetAgentResponse", [
            { no: 1, name: "agent_view", kind: "message", T: () => AgentView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetAgentResponse
 */
export const GetAgentResponse = new GetAgentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAgentsRequest$Type extends MessageType<ListAgentsRequest> {
    constructor() {
        super("c1.api.user.v1.ListAgentsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.ListAgentsRequest
 */
export const ListAgentsRequest = new ListAgentsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAgentsResponse$Type extends MessageType<ListAgentsResponse> {
    constructor() {
        super("c1.api.user.v1.ListAgentsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AgentView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.ListAgentsResponse
 */
export const ListAgentsResponse = new ListAgentsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAgentInstructionsRequest$Type extends MessageType<SetAgentInstructionsRequest> {
    constructor() {
        super("c1.api.user.v1.SetAgentInstructionsRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "agent_instructions_type", kind: "enum", T: () => ["c1.api.user.v1.AgentInstructionsType", AgentInstructionsType, "AGENT_INSTRUCTIONS_TYPE_"], options: { "validate.rules": { enum: { definedOnly: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetAgentInstructionsRequest
 */
export const SetAgentInstructionsRequest = new SetAgentInstructionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAgentInstructionsResponse$Type extends MessageType<SetAgentInstructionsResponse> {
    constructor() {
        super("c1.api.user.v1.SetAgentInstructionsResponse", [
            { no: 1, name: "agent_view", kind: "message", T: () => AgentView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetAgentInstructionsResponse
 */
export const SetAgentInstructionsResponse = new SetAgentInstructionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAgentRequest$Type extends MessageType<DeleteAgentRequest> {
    constructor() {
        super("c1.api.user.v1.DeleteAgentRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.DeleteAgentRequest
 */
export const DeleteAgentRequest = new DeleteAgentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAgentResponse$Type extends MessageType<DeleteAgentResponse> {
    constructor() {
        super("c1.api.user.v1.DeleteAgentResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.DeleteAgentResponse
 */
export const DeleteAgentResponse = new DeleteAgentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgentRef$Type extends MessageType<AgentRef> {
    constructor() {
        super("c1.api.user.v1.AgentRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.AgentRef
 */
export const AgentRef = new AgentRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAgentsRequest$Type extends MessageType<SearchAgentsRequest> {
    constructor() {
        super("c1.api.user.v1.SearchAgentsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 10 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AgentRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchAgentsRequest
 */
export const SearchAgentsRequest = new SearchAgentsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAgentsResponse$Type extends MessageType<SearchAgentsResponse> {
    constructor() {
        super("c1.api.user.v1.SearchAgentsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AgentView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SearchAgentsResponse
 */
export const SearchAgentsResponse = new SearchAgentsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExpiringUserDelegationBindingRequest$Type extends MessageType<GetExpiringUserDelegationBindingRequest> {
    constructor() {
        super("c1.api.user.v1.GetExpiringUserDelegationBindingRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetExpiringUserDelegationBindingRequest
 */
export const GetExpiringUserDelegationBindingRequest = new GetExpiringUserDelegationBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetExpiringUserDelegationBindingResponse$Type extends MessageType<GetExpiringUserDelegationBindingResponse> {
    constructor() {
        super("c1.api.user.v1.GetExpiringUserDelegationBindingResponse", [
            { no: 1, name: "item", kind: "message", T: () => ExpiringUserDelegationBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetExpiringUserDelegationBindingResponse
 */
export const GetExpiringUserDelegationBindingResponse = new GetExpiringUserDelegationBindingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetExpiringUserDelegationBindingByAdminRequest$Type extends MessageType<SetExpiringUserDelegationBindingByAdminRequest> {
    constructor() {
        super("c1.api.user.v1.SetExpiringUserDelegationBindingByAdminRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "delegated_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 3, name: "delegation_start_at", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false } } } },
            { no: 4, name: "delegation_expire_at", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingByAdminRequest
 */
export const SetExpiringUserDelegationBindingByAdminRequest = new SetExpiringUserDelegationBindingByAdminRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetExpiringUserDelegationBindingByAdminResponse$Type extends MessageType<SetExpiringUserDelegationBindingByAdminResponse> {
    constructor() {
        super("c1.api.user.v1.SetExpiringUserDelegationBindingByAdminResponse", [
            { no: 1, name: "item", kind: "message", T: () => ExpiringUserDelegationBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingByAdminResponse
 */
export const SetExpiringUserDelegationBindingByAdminResponse = new SetExpiringUserDelegationBindingByAdminResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetExpiringUserDelegationBindingSelfRequest$Type extends MessageType<SetExpiringUserDelegationBindingSelfRequest> {
    constructor() {
        super("c1.api.user.v1.SetExpiringUserDelegationBindingSelfRequest", [
            { no: 1, name: "delegated_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "delegation_start_at", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false } } } },
            { no: 3, name: "delegation_expire_at", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingSelfRequest
 */
export const SetExpiringUserDelegationBindingSelfRequest = new SetExpiringUserDelegationBindingSelfRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetExpiringUserDelegationBindingSelfResponse$Type extends MessageType<SetExpiringUserDelegationBindingSelfResponse> {
    constructor() {
        super("c1.api.user.v1.SetExpiringUserDelegationBindingSelfResponse", [
            { no: 1, name: "item", kind: "message", T: () => ExpiringUserDelegationBinding }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetExpiringUserDelegationBindingSelfResponse
 */
export const SetExpiringUserDelegationBindingSelfResponse = new SetExpiringUserDelegationBindingSelfResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserProfileTypesRequest$Type extends MessageType<GetUserProfileTypesRequest> {
    constructor() {
        super("c1.api.user.v1.GetUserProfileTypesRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetUserProfileTypesRequest
 */
export const GetUserProfileTypesRequest = new GetUserProfileTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserProfileTypesResponse$Type extends MessageType<GetUserProfileTypesResponse> {
    constructor() {
        super("c1.api.user.v1.GetUserProfileTypesResponse", [
            { no: 1, name: "profile_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileType }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.GetUserProfileTypesResponse
 */
export const GetUserProfileTypesResponse = new GetUserProfileTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PreviewUserProfileWithProfileTypesRequest$Type extends MessageType<PreviewUserProfileWithProfileTypesRequest> {
    constructor() {
        super("c1.api.user.v1.PreviewUserProfileWithProfileTypesRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "profile_type_ids_to_add", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "100" } } } },
            { no: 3, name: "profile_type_ids_to_remove", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "100" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.PreviewUserProfileWithProfileTypesRequest
 */
export const PreviewUserProfileWithProfileTypesRequest = new PreviewUserProfileWithProfileTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PreviewUserProfileWithProfileTypesResponse$Type extends MessageType<PreviewUserProfileWithProfileTypesResponse> {
    constructor() {
        super("c1.api.user.v1.PreviewUserProfileWithProfileTypesResponse", [
            { no: 1, name: "current_profile", kind: "message", T: () => Struct },
            { no: 2, name: "projected_profile", kind: "message", T: () => Struct },
            { no: 3, name: "potentially_affected_references", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AffectedReference }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.PreviewUserProfileWithProfileTypesResponse
 */
export const PreviewUserProfileWithProfileTypesResponse = new PreviewUserProfileWithProfileTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AffectedReference$Type extends MessageType<AffectedReference> {
    constructor() {
        super("c1.api.user.v1.AffectedReference", [
            { no: 1, name: "entity_type", kind: "enum", T: () => ["c1.api.user.v1.AffectedReferenceEntityType", AffectedReferenceEntityType, "AFFECTED_REFERENCE_ENTITY_TYPE_"] },
            { no: 2, name: "entity_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entity_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cel_expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "referenced_changing_fields", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.AffectedReference
 */
export const AffectedReference = new AffectedReference$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetUserAvatarRequest$Type extends MessageType<SetUserAvatarRequest> {
    constructor() {
        super("c1.api.user.v1.SetUserAvatarRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "validate.rules": { bytes: { minLen: "4", maxLen: "1000000" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetUserAvatarRequest
 */
export const SetUserAvatarRequest = new SetUserAvatarRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetUserAvatarResponse$Type extends MessageType<SetUserAvatarResponse> {
    constructor() {
        super("c1.api.user.v1.SetUserAvatarResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetUserAvatarResponse
 */
export const SetUserAvatarResponse = new SetUserAvatarResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetUserAvatarSelfRequest$Type extends MessageType<SetUserAvatarSelfRequest> {
    constructor() {
        super("c1.api.user.v1.SetUserAvatarSelfRequest", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "validate.rules": { bytes: { minLen: "4", maxLen: "1000000" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetUserAvatarSelfRequest
 */
export const SetUserAvatarSelfRequest = new SetUserAvatarSelfRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetUserAvatarSelfResponse$Type extends MessageType<SetUserAvatarSelfResponse> {
    constructor() {
        super("c1.api.user.v1.SetUserAvatarSelfResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.user.v1.SetUserAvatarSelfResponse
 */
export const SetUserAvatarSelfResponse = new SetUserAvatarSelfResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.user.v1.UserService
 */
export const UserService = new ServiceType("c1.api.user.v1.UserService", [
    { name: "Introspect", options: { "authz.method": { role: "REFLECTION" } }, I: IntrospectRequest, O: IntrospectResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/users/{id}", group: "User" }] } }, I: UserServiceGetRequest, O: UserServiceGetResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/users", query: { page_size: "page_size", page_token: "page_token" }, group: "User" }] } }, I: UserServiceListRequest, O: UserServiceListResponse },
    { name: "GetByIDs", options: { "authz.method": { role: "VIEWER" } }, I: UserServiceGetUsersByIDsRequest, O: UserServiceGetUsersByIDsResponse },
    { name: "Update", options: { "authz.method": { role: "OWNER" } }, I: UpdateUserRequest, O: UserServiceGetResponse },
    { name: "SetDelegatedUser", options: { "authz.method": { role: "EDITOR" } }, I: SetDelegatedUserRequest, O: UserServiceGetResponse },
    { name: "SetUserRoles", options: { "authz.method": { role: "EDITOR" } }, I: SetUserRolesRequest, O: UserServiceGetResponse },
    { name: "GetExpiringUserDelegationBinding", options: { "authz.method": { role: "VIEWER" } }, I: GetExpiringUserDelegationBindingRequest, O: GetExpiringUserDelegationBindingResponse },
    { name: "SetExpiringUserDelegationBindingByAdmin", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/users/{user_id}/set-delegation-by-admin", group: "User" }] } }, I: SetExpiringUserDelegationBindingByAdminRequest, O: SetExpiringUserDelegationBindingByAdminResponse },
    { name: "SetExpiringUserDelegationBindingSelf", options: { "authz.method": { role: "EDITOR" } }, I: SetExpiringUserDelegationBindingSelfRequest, O: SetExpiringUserDelegationBindingSelfResponse },
    { name: "GetUserProfileTypes", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/users/{user_id}/profile-types", group: "User" }] } }, I: GetUserProfileTypesRequest, O: GetUserProfileTypesResponse },
    { name: "PreviewUserProfileWithProfileTypes", options: { "authz.method": { role: "VIEWER" } }, I: PreviewUserProfileWithProfileTypesRequest, O: PreviewUserProfileWithProfileTypesResponse },
    { name: "SetUserAvatar", options: { "authz.method": { role: "OWNER" } }, I: SetUserAvatarRequest, O: SetUserAvatarResponse },
    { name: "SetUserAvatarSelf", options: { "authz.method": { role: "EDITOR" } }, I: SetUserAvatarSelfRequest, O: SetUserAvatarSelfResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.user.v1.UserSearch
 */
export const UserSearch = new ServiceType("c1.api.user.v1.UserSearch", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/users", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "User", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }, { type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Users", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "User", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", in: "TERRAFORM_ENTITY_PAGINATION_INPUT_IN_REQUEST_BODY", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: SearchUsersRequest, O: SearchUsersResponse },
    { name: "SearchManagedUsers", options: { "authz.method": { role: "VIEWER" } }, I: SearchManagedUsersRequest, O: SearchManagedUsersResponse },
    { name: "SearchManagedUsersForAccessRequests", options: { "authz.method": { role: "VIEWER" } }, I: SearchManagedUsersForAccessRequestsRequest, O: SearchManagedUsersForAccessRequestsResponse },
    { name: "CountAppUsersWithoutManager", options: { "authz.method": { role: "VIEWER" } }, I: CountAppUsersWithoutManagerRequest, O: CountAppUsersWithoutManagerResponse },
    { name: "UsersWithoutManager", options: { "authz.method": { role: "VIEWER" } }, I: UsersWithoutManagerRequest, O: UsersWithoutManagerResponse },
    { name: "SearchUsersWithUnspecifiedEmploymentStatus", options: { "authz.method": { role: "VIEWER" } }, I: UsersWithUnspecifiedEmploymentStatusRequest, O: UsersWithUnspecifiedEmploymentStatusResponse },
    { name: "SearchWithCEL", options: { "authz.method": { role: "VIEWER" } }, I: SearchUsersWithCELRequest, O: SearchUsersWithCELResponse },
    { name: "SearchUserAttributesWithProfileTypeSource", options: { "authz.method": { role: "VIEWER" } }, I: SearchUserAttributesWithProfileTypeSourceRequest, O: SearchUserAttributesWithProfileTypeSourceResponse },
    { name: "GetEmploymentStatusSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: GetEmploymentStatusSearchTermsRequest, O: GetEmploymentStatusSearchTermsResponse },
    { name: "GetJobTitleSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: GetJobTitleSearchTermsRequest, O: GetJobTitleSearchTermsResponse },
    { name: "GetDepartmentSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: GetDepartmentSearchTermsRequest, O: GetDepartmentSearchTermsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.user.v1.AgentService
 */
export const AgentService = new ServiceType("c1.api.user.v1.AgentService", [
    { name: "CreateAgent", options: { "authz.method": { role: "OWNER" } }, I: CreateAgentRequest, O: CreateAgentResponse },
    { name: "GetAgent", options: { "authz.method": { role: "OWNER" } }, I: GetAgentRequest, O: GetAgentResponse },
    { name: "SetAgentInstructions", options: { "authz.method": { role: "OWNER" } }, I: SetAgentInstructionsRequest, O: SetAgentInstructionsResponse },
    { name: "DeleteAgent", options: { "authz.method": { role: "OWNER" } }, I: DeleteAgentRequest, O: DeleteAgentResponse },
    { name: "ListAgents", options: { "authz.method": { role: "OWNER" } }, I: ListAgentsRequest, O: ListAgentsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.user.v1.AgentSearchService
 */
export const AgentSearchService = new ServiceType("c1.api.user.v1.AgentSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchAgentsRequest, O: SearchAgentsResponse }
]);
